import src from "IMAGE";
export default { src, width: 134, height: 39, blurWidth: 0, blurHeight: 0};
